<template>
  <div class="confirmation__header">
    <div class="confirmation__header--title" :class="variant">
      {{ title }}
    </div>
    <hcc-button-icon
      round
      class="confirmation__header--icon"
      v-if="variant === 'error'"
      color="alert"
    >
      <delete-icon/>
    </hcc-button-icon>
    <hcc-button-icon
      round
      class="confirmation__header--icon"
      v-else-if="variant === 'info'"
      color="primary"
    >
      <info-icon/>
    </hcc-button-icon>
    <hcc-button-icon
      round
      class="confirmation__header--icon"
      color="secondary"
      v-else
    >
      <priority-high-icon/>
    </hcc-button-icon>
  </div>
</template>

<script>
import deleteIcon from '@/assets/icons/components/delete-icon.svg';
import infoIcon from '@/assets/icons/components/info.svg';
import priorityHighIcon from '@/assets/icons/components/priority-high.svg';
import HccButtonIcon from '../HccButtonIcon/index.vue';

export default {
  components: {
    HccButtonIcon,
    deleteIcon,
    infoIcon,
    priorityHighIcon,
  },
  props: {
    title: {
      type: String,
    },
    variant: {
      type: String,
    },
  },

};
</script>

<style scoped lang="scss">
@import "~styles/shared/confirmation.scss";

.test {
  color: white;
}
</style>
